import { EmptyStatePlaceholder } from '@dreryk/react-components';

import { boundServiceTranslationKeys, patientPortalTranslationKeys } from '../../translations';

import { AddNewBoundServiceModalOpener } from './AddNewBoundServiceModalOpener';

type CurrentHealthcareProviderBoundServiceTableEmptyStatePlaceholderProps = {
   readonly onBoundServiceCreateSuccess: VoidFunction;
};
export const CurrentHealthcareProviderBoundServiceTableEmptyStatePlaceholder = (
   props: CurrentHealthcareProviderBoundServiceTableEmptyStatePlaceholderProps
): JSX.Element => (
   <EmptyStatePlaceholder
      heading={patientPortalTranslationKeys.boundServices.noBoundedServices}
      testId={'noBoundedServices'}
      subheading={patientPortalTranslationKeys.boundServices.placeholder}
   >
      <AddNewBoundServiceModalOpener
         label={boundServiceTranslationKeys.addNewBound}
         onBoundServiceCreateSuccess={props.onBoundServiceCreateSuccess}
         withLeadingIcon={false}
      />
   </EmptyStatePlaceholder>
);
